export default __webpack_public_path__ + "static/media/larplogo.91173cfb.jpeg";